/* eslint-disable */
import React from "react";
import { useState } from "react";
import { Chart } from "react-google-charts";
import HeAppWrapper from "../../components/HeAppWrapper";

import "./App.scss";

import useScript from "../../hooks/useScript";
import { useEffect } from "react";

let data_url = "/wp-content/plugins/he-apps/legacyResources/appData/homes-data/homes-table-mt/";
let d3;

function App() {
    const [state, setState] = useState({
        data: null,
        allScriptsLoaded: false
    });

    useEffect(() => {
        if (state.allScriptsLoaded) {
            d3 = window.d3;
            loadData();
        }
    }, [state.allScriptsLoaded]);

    const [loaded1, error1] = useScript("/wp-content/plugins/he-apps/legacyResources/jsLibs/d3/d3.min.js");
    if (!state.allScriptsLoaded && loaded1) {
        setState(prev => ({ ...prev, allScriptsLoaded: true }));
    }
 
    const loadData = () => {
        let data = [];
        data.push([
            { type: "string", label: "County" },
            { type: "number", label: "Acres of 0pen space converted, 1990-2018", width: 80 },
            { type: "number", label: "Count of homes in 2018" },
            { type: "number", label: "Count of homes built, 1990-2018" },
            { type: "number", label: "Pct. of Homes Built in Areas Where Average Lot Sizes Exceed 10 Acres, 1990-2018", width: "80px" },
            { type: "number", label: "Pct. of Homes Built Outside Incorporated City Boundaries, 1990-2018" }
        ]);

        let title = "Montana Homes Data"; 

        d3.csv(data_url + "homes-mt-2016.csv", function(error, tableData) {
            tableData.forEach(row => {
                let dataRow = [row.county];
                dataRow.push({ v: row.homes_total, f: decimalFormatter.format(row.homes_total) });
                dataRow.push({ v: row.homes_1900_2018, f: decimalFormatter.format(row.homes_1900_2018) });
                dataRow.push({ v: row.acres_open_space, f: decimalFormatter.format(row.acres_open_space) });
                dataRow.push({ v: row.homes_10_acres, f: percentFormatter.format(row.homes_10_acres / 100) });
                dataRow.push({ v: row.homes_city, f: percentFormatter.format(row.homes_city / 100) });
                data.push(dataRow);
            });
            setState(prev => ({ ...prev, data: data }));
        });
    };

    return (
        <HeAppWrapper className="app-montana-home-construction-table">
            <Chart
                chartType="Table"
                loader={<div>Loading Table</div>}
                data={state.data}
                width={900}
                options={{
                    showRowNumber: true,
                    cssClassNames: { headerCell: "he-google-sortable-table" }
                }}
            />
        </HeAppWrapper>
    );
}

export default App;

const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 0
});
const decimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0
});
